
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M44 30L24 18v24l20-12z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.469 30.312c0-12.355 10.088-22.4 22.496-22.4 12.398 0 22.497 10.045 22.497 22.4 0 12.355-10.089 22.4-22.497 22.4S7.47 42.668 7.47 30.313zm2 0c0 11.25 9.198 20.41 20.496 20.41 11.299 0 20.497-9.16 20.497-20.41S41.264 9.903 29.965 9.903c-11.298 0-20.497 9.16-20.497 20.41z"}})])
          )
        }
      }
    